/* Little Paw Folk: "Buy it as a pair" bundle offer.
 * Adds the main product and its partner in one request. The saving itself is an
 * automatic Shopify discount; this script only adds the items and shows the numbers. */
(function () {
  if (customElements.get('lpf-bundle-offer')) return;

  const BUNDLE_PREFIX = 'Bundle & save';

  class LpfBundleOffer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-lpf-bo-data]').textContent);
      } catch (e) {
        return; // leave the server-rendered offer and plain form in place
      }
      this.saveCents = parseInt(this.dataset.saveCents, 10) || 0;
      this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.form = this.querySelector('[data-lpf-bo-form]');
      this.btn = this.querySelector('[data-lpf-bo-btn]');
      this.btnLabel = this.querySelector('[data-lpf-bo-btn-label]');
      this.statusEl = this.querySelector('[data-lpf-bo-status]');
      this.errorEl = this.querySelector('[data-lpf-bo-error]');
      this.busy = false;
      this.cart = null;
      this.addError = '';

      this.mainId = parseInt(this.querySelector('[data-lpf-bo-main-id]').value, 10);
      this.partnerId = parseInt(this.querySelector('[data-lpf-bo-partner-id]').value, 10);

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.add();
      });
      this.querySelectorAll('[data-lpf-bo-option]').forEach((sel) =>
        sel.addEventListener('change', () => this.onPartnerOptionChange())
      );

      // Main product variant changes (the theme sets the form input and fires "change").
      this._onDocChange = (e) => {
        const t = e.target;
        if (!t || t.name !== 'id' || !t.closest) return;
        const form = t.closest('form');
        // getAttribute, not form.id: the form has an input named "id", which shadows form.id.
        if (!form || form.getAttribute('id') !== `product-form-${this.dataset.sectionId}`) return;
        this.setMainVariant(parseInt(t.value, 10));
      };
      document.addEventListener('change', this._onDocChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          const v = evt && evt.data && evt.data.variant;
          if (v && evt.data.sectionId === this.dataset.sectionId) this.setMainVariant(v.id);
        });
        this._unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (!evt || evt.source !== 'lpf-bundle-offer') this.refreshCart();
        });
      }
      // Re-check when the shopper returns to this tab, in case the cart changed in another tab.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.refreshCart();
      });

      this.markPartnerOptions();
      this.render();
      this.refreshCart();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this._onDocChange);
      this._unsubVariant && this._unsubVariant();
      this._unsubCart && this._unsubCart();
    }

    get mainVariant() {
      return this.data.main.find((v) => v.id === this.mainId) || null;
    }
    get partnerVariant() {
      return this.data.partner.find((v) => v.id === this.partnerId) || null;
    }

    fmt(cents) {
      return this.money.format(cents / 100);
    }
    fmtShort(cents) {
      return cents % 100 === 0 ? this.fmt(cents).replace(/\.00$/, '') : this.fmt(cents);
    }

    setMainVariant(id) {
      if (!id || id === this.mainId) return;
      this.mainId = id;
      this.querySelector('[data-lpf-bo-main-id]').value = id;
      this.addError = '';
      this.render();
    }

    selectedPartnerOptions() {
      return Array.from(this.querySelectorAll('[data-lpf-bo-option]')).map((s) => s.value);
    }

    onPartnerOptionChange() {
      const opts = this.selectedPartnerOptions();
      const match = this.data.partner.find((v) => v.options.every((o, i) => o === opts[i]));
      this.partnerId = match ? match.id : null;
      this.querySelector('[data-lpf-bo-partner-id]').value = match ? match.id : '';
      this.addError = '';
      this.markPartnerOptions();
      this.render();
    }

    // Label option values that cannot be bought with the other current choices.
    markPartnerOptions() {
      const selects = Array.from(this.querySelectorAll('[data-lpf-bo-option]'));
      if (!selects.length) return;
      const current = this.selectedPartnerOptions();
      selects.forEach((sel, idx) => {
        Array.from(sel.options).forEach((opt) => {
          const combo = current.slice();
          combo[idx] = opt.value;
          const v = this.data.partner.find((x) => x.options.every((o, i) => o === combo[i]));
          const ok = !!(v && v.available);
          opt.textContent = ok ? opt.value : `${opt.value} (sold out)`;
        });
      });
    }

    // Original price: the compare-at price only when it is above the current price.
    orig(v) {
      return v.compare && v.compare > v.price ? v.compare : v.price;
    }

    renderPrice(el, v) {
      if (!el) return;
      el.textContent = '';
      if (this.orig(v) > v.price) {
        const s = document.createElement('s');
        s.className = 'lpf-bo__was';
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = `${this.dataset.wasLabel || 'Original price'} `;
        s.appendChild(label);
        s.appendChild(document.createTextNode(this.fmt(this.orig(v))));
        el.appendChild(s);
        el.appendChild(document.createTextNode(' '));
        const h = document.createElement('span');
        h.className = 'visually-hidden';
        h.textContent = 'Sale price ';
        el.appendChild(h);
      }
      const now = document.createElement('span');
      now.className = 'lpf-bo__now';
      now.textContent = this.fmt(v.price);
      el.appendChild(now);
    }

    setImage(holderSel, src, alt) {
      if (!src) return;
      const holder = this.querySelector(holderSel);
      if (!holder) return;
      let img = holder.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.width = 72;
        img.height = 72;
        img.alt = alt || '';
        holder.appendChild(img);
      }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    }

    // True when the cart already holds a bundle saving from a different pair. Only one bundle
    // discount applies per order, so this pair would not add a further saving.
    otherBundleInCart() {
      if (!this.cart) return false;
      const own = (this.dataset.discountTitles || '').split('|').filter(Boolean);
      return this.cart.items.some((i) =>
        (i.line_level_discount_allocations || []).some((a) => {
          const t = String((a.discount_application && a.discount_application.title) || '');
          return t.indexOf(BUNDLE_PREFIX) === 0 && own.indexOf(t) === -1;
        })
      );
    }

    pairAlreadyInCart() {
      if (!this.cart) return false;
      const ids = this.cart.items.map((i) => i.variant_id);
      return ids.includes(this.mainId) && ids.includes(this.partnerId);
    }

    render() {
      const m = this.mainVariant;
      const p = this.partnerVariant;
      const mainVariantEl = this.querySelector('[data-lpf-bo-main-variant]');
      if (m) {
        this.renderPrice(this.querySelector('[data-lpf-bo-main-price]'), m);
        if (mainVariantEl) mainVariantEl.textContent = m.title;
        this.setImage('[data-lpf-bo-main-img]', m.image, this.data.mainName);
      }
      if (p) {
        this.renderPrice(this.querySelector('[data-lpf-bo-partner-price]'), p);
        this.setImage('[data-lpf-bo-partner-img]', p.image, '');
      }

      const note = this.querySelector('[data-lpf-bo-note]');
      const totalEl = this.querySelector('[data-lpf-bo-total]');

      let problem = '';
      if (!m || !m.available) problem = 'This option is sold out. Choose another option above.';
      else if (!p) problem = 'That combination is not available. Choose another option.';
      else if (!p.available) problem = `${this.data.partnerName} in ${p.title} is sold out. Choose another option.`;

      if (m && p) {
        const subtotal = m.price + p.price;
        const original = this.orig(m) + this.orig(p);
        const anySale = this.orig(m) > m.price || this.orig(p) > p.price;
        const bothSale = this.orig(m) > m.price && this.orig(p) > p.price;
        const other = this.otherBundleInCart();
        const bundle = other ? 0 : Math.min(this.saveCents, p.price);
        const final = subtotal - bundle;
        const totalSaving = original - final; // sale savings + bundle discount, counted once

        this.querySelector('[data-lpf-bo-subtotal-label]').textContent = `${anySale ? 'Sale subtotal' : 'Subtotal'} (1 of each)`;
        this.querySelector('[data-lpf-bo-subtotal]').textContent = this.fmt(subtotal);
        const dRow = this.querySelector('[data-lpf-bo-discount-row]');
        dRow.hidden = bundle === 0;
        this.querySelector('[data-lpf-bo-discount-label]').textContent = `${anySale ? 'Extra ' : ''}${this.fmtShort(bundle)} bundle discount`;
        this.querySelector('[data-lpf-bo-discount]').textContent = `−${this.fmt(bundle)}`;
        totalEl.textContent = this.fmt(final);
        const saveEl = this.querySelector('[data-lpf-bo-save]');
        saveEl.hidden = totalSaving <= 0;
        this.querySelector('[data-lpf-bo-total-saving]').textContent = this.fmt(totalSaving);

        const lead = this.querySelector('[data-lpf-bo-lead]');
        lead.textContent = other
          ? 'Your cart already has a bundle discount. One bundle discount applies per order.'
          : bothSale
          ? `Get both sale prices, plus an extra ${this.fmtShort(bundle)} off when you buy together.`
          : `Buy both together and get ${this.fmtShort(bundle)} off.`;
        note.textContent = other
          ? 'Only one bundle discount applies per order, so this pair would be charged at the prices shown above.'
          : `The ${this.fmtShort(bundle)} comes off automatically in your cart, no code needed. One bundle discount per order. Items ship separately.`;
      }

      if (this.busy) return;
      if (problem) {
        this.btn.disabled = true;
        this.btnLabel.textContent = 'Unavailable';
        this.showError(problem);
      } else if (this.pairAlreadyInCart()) {
        this.btn.disabled = false;
        this.btnLabel.textContent = 'Both are in your cart. View cart';
        this.showError(this.addError);
      } else {
        this.btn.disabled = false;
        this.btnLabel.textContent = 'Add bundle to cart';
        this.showError(this.addError);
      }
    }

    showError(msg) {
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }
    showStatus(msg) {
      this.statusEl.textContent = msg || '';
    }

    async refreshCart() {
      try {
        const r = await fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (r.ok) {
          this.cart = await r.json();
          this.render();
        }
      } catch (e) {
        /* keep the last known state */
      }
    }

    get drawer() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    openCart() {
      const d = this.drawer;
      if (d && typeof d.open === 'function' && this.dataset.cartType !== 'page') d.open(this.btn);
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }

    async renderDrawer(sections) {
      const d = this.drawer;
      if (!d || typeof d.renderContents !== 'function') return false;
      let s = sections;
      if (!s) {
        const ids = d.getSectionsToRender().map((x) => x.id).join(',');
        const r = await fetch(`${window.location.pathname}?sections=${ids}`);
        if (!r.ok) return false;
        s = await r.json();
      }
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) drawerEl.classList.remove('is-empty');
      d.renderContents({ sections: s });
      return true;
    }

    async add() {
      if (this.busy || this.btn.disabled) return;
      const m = this.mainVariant;
      const p = this.partnerVariant;
      if (!m || !p || !m.available || !p.available) return;

      this.busy = true;
      this.btn.disabled = true;
      this.btn.setAttribute('aria-busy', 'true');
      this.classList.add('lpf-bo--loading');
      this.btnLabel.textContent = 'Adding…';
      this.addError = '';
      this.showError('');
      this.showStatus('');

      try {
        await this.refreshCart();
        const before = this.cart;
        const inCart = new Set(before ? before.items.map((i) => i.variant_id) : []);
        const wanted = [
          { id: m.id, name: this.data.mainName, title: m.title },
          { id: p.id, name: this.data.partnerName, title: p.title },
        ];
        const toAdd = wanted.filter((w) => !inCart.has(w.id));
        const skipped = wanted.filter((w) => inCart.has(w.id));

        if (toAdd.length === 0) {
          this.busy = false;
          this.showStatus('Both items are already in your cart, so nothing was added.');
          this.openCart();
          return;
        }

        const d = this.drawer;
        const body = { items: toAdd.map((w) => ({ id: w.id, quantity: 1 })) };
        if (d && typeof d.getSectionsToRender === 'function' && this.dataset.cartType !== 'page') {
          body.sections = d.getSectionsToRender().map((x) => x.id).join(',');
          body.sections_url = window.location.pathname;
        }
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const data = await res.json().catch(() => ({}));

        if (!res.ok || data.status) {
          // Report exactly what did and did not reach the cart.
          await this.refreshCart();
          const nowIds = new Set(this.cart ? this.cart.items.map((i) => i.variant_id) : []);
          const added = toAdd.filter((w) => nowIds.has(w.id) && !inCart.has(w.id));
          const reason = data.description || data.message || 'Please try again.';
          this.addError = added.length
            ? `We added ${added.map((w) => w.name).join(' and ')}, but the other item could not be added. ${reason}`
            : `The pair could not be added. ${reason}`;
          this.showError(this.addError);
          if (added.length) await this.renderDrawer();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'lpf-bundle-offer', errors: reason });
          }
          return;
        }

        if (this.dataset.cartType === 'page' || !d) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        const beforeDiscount = before ? before.total_discount || 0 : 0;
        await this.refreshCart();
        const gained = this.cart ? (this.cart.total_discount || 0) - beforeDiscount : 0;

        let msg = skipped.length
          ? `${skipped.map((w) => w.name).join(' and ')} was already in your cart, so we added ${toAdd
              .map((w) => w.name)
              .join(' and ')}.`
          : 'Both items were added to your cart.';
        msg += gained > 0 ? ` Your ${this.fmtShort(gained)} bundle discount is applied.` : '';
        this.showStatus(msg);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lpf-bundle-offer', cartData: data });
        }
        if (data.sections) await this.renderDrawer(data.sections);
        else await this.renderDrawer();
      } catch (e) {
        this.addError = 'Something went wrong and the pair was not added. Please check your connection and try again.';
        this.showError(this.addError);
      } finally {
        this.busy = false;
        this.btn.removeAttribute('aria-busy');
        this.classList.remove('lpf-bo--loading');
        this.render();
      }
    }
  }

  customElements.define('lpf-bundle-offer', LpfBundleOffer);
})();
